export default "__VITE_ASSET__DNx8$ZUF__"